import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {Home} from "./home.tsx";
import {Container, MantineProvider} from "@mantine/core";
import {BrowserRouter, Route, Routes} from "react-router";
import {ExerciseInfo} from "./exercise_info.tsx";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <BrowserRouter>
      <MantineProvider>
        <Container padding="md" mt="lg">
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/:exercise" element={<ExerciseInfo/>}/>
          </Routes>
        </Container>
      </MantineProvider>
    </BrowserRouter>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
